import { useMemo } from "react";
import apiInstance from "../../helpers/apiInstance";

function useSignup() {
  const basePath = useMemo(() => {
    return `/auth`;
  }, []);

  return {
    signup: (payload) => apiInstance.post(basePath + "/register", payload),
    verifySignup: (variables) => {
      const { payload, token } = variables;

      return apiInstance.post(basePath + "/verify/" + token, payload);
    },
    login: (payload) => apiInstance.post(basePath + "/login", payload),
    googleCallback: () => {
      const apiEndpoint =
        basePath + "/google/callback" + window.location.search;

      return apiInstance.get(apiEndpoint);
    },
    forgotPassword: (payload) =>
      apiInstance.post(basePath + "/forgot-password", payload),
    changePassword: (variables) => {
      const { payload, token } = variables;

      return apiInstance.put(basePath + "/change-password/" + token, payload);
    },

    resetPassword: (payload) =>
      apiInstance.put(basePath + "/reset-password", payload),
  };
}

export default useSignup;
